import React from 'react';
import { CascadingFieldOptionsList, type Props } from './view.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { ParentId } from './view';

export type OwnProps = Omit<Props, 'parentId'>;

export const RootOptionsList = (props: OwnProps) => (
	<CascadingFieldOptionsList {...props} parentId="root" />
);
